<script>
    import Thumbnail from '../../common/Media/Thumbnail.svelte';
    export let data = {};

</script>

<style>

</style>

{#if data && data.url}
    <Thumbnail 
        url={data.thumbnail ? data.thumbnail : data.url}
        media={data.url}
        name={data.name}
        type={data.type}
    />
{/if}